import React, { FC } from 'react';

import * as styles from './PopoverContent.scss';

const PopoverContentSeparator: FC = () => (
  <div key="separator" role="separator" className={styles.separator} />
);

export default PopoverContentSeparator;
